<template>
  <fieldset>
    <legend class="visuallyhidden">Invoice information</legend>
    <div class="field">
      <div class="field-body">
        <div class="field">
          <label class="label input-wrapper" :class="{ active: form.invoiceNumber }">
            <span class="input-label">Invoice Number</span>
            <input v-model="form.invoiceNumber" v-validate="'required'" name="invoice_number" class="input" type="text" placeholder="Invoice number">
            <span class="form-messages">{{ errors.first('invoice_number') }}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="field">
      <div class="field-body">
        <div class="field">
          <label class="label input-wrapper active">
            <span class="input-label">Invoice Date</span>
            <input v-model="form.invoiceDate" name="invoice_date" class="input" type="date">
            <span class="form-messages">{{ errors.first('invoice_date') }}</span>
          </label>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'InvoiceFormInformationFields',
  props: {
    form: {
      type: Object,
      required: true
    }
  }
}
</script>
